import type { IntlShape } from "react-intl";
import { z } from "zod";

const campaignImageDimensionsSchema = z.object({
	length: z.number(),
	width: z.number(),
	height: z.number(),
});

const campaignImageSchema = z.object({
	filename: z.string(),
	filePath: z.string(),
	targetQuantity: z.number(),
	quantityProduced: z.number(),
	dimensions: campaignImageDimensionsSchema,
	queuedQuantity: z.number(),
});

export const campaignSchema = z.object({
	id: z.string(),
	campaignName: z.string(),
	startDate: z.string(),
	endDate: z.string(),
	campaignImages: z.array(campaignImageSchema),
	isActive: z.boolean(),
});

export type Campaign = z.infer<typeof campaignSchema>;

export const getPrintCampaignConfigurationSchema = (intl: IntlShape) =>
	z.object({
		file: z
			.custom<File>((value) => typeof File !== "undefined" && value instanceof File)
			.nullable()
			.superRefine((file, context) => {
				if (file === null) {
					context.addIssue({
						code: "custom",
						message: intl.formatMessage({
							id: "A CSV file is required",
							defaultMessage: "A CSV file is required",
						}),
					});
				}
			}),
		campaigns: z.array(campaignSchema).min(1, {
			message: intl.formatMessage({
				id: "The CSV file must contain at least one campaign",
				defaultMessage: "The CSV file must contain at least one campaign",
			}),
		}),
	});

export type PrintCampaignConfiguration = z.infer<ReturnType<typeof getPrintCampaignConfigurationSchema>>;
